import * as React from "react";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#d1cfd5",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function GroupList(props) {
  const { groupList, handleSelectGroup, selectedGroup } = props;

  return (
    <Box sx={{ height: "55%" }}>
      <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{ flexWrap: "wrap", overflowY: "scroll", height: "100%" }}
      >
        {groupList.map((grpName, index) => (
          <Item
            onClick={() => {
              handleSelectGroup(grpName);
            }}
            sx={{ m: 0.5 }}
            key={grpName + index}
          >
            <Typography
              sx={{
                cursor: "pointer",
                color: grpName == selectedGroup ? "red" : "blue",
              }}
            >
              {grpName}
            </Typography>
          </Item>
        ))}
      </Stack>
    </Box>
  );
}
